import { createApp } from 'vue'
import HomePage from './index';
import i18n from '../../i18n';
import mitt from 'mitt';

import '../../styles/general.less';

const emitter = mitt();

const app = createApp(HomePage);
app.config.globalProperties.emitter = emitter;
app.use(i18n);
app.mount('#app');